import baseAPI from '@/api/base';
import {
  EditEventTemplate,
  GetEventTemplate,
  RegisterEventTemplate,
} from '@/dtos/event_template.dto';
import {
  DELETE_EVENT_TEMPLATE_URL,
  EDIT_EVENT_TEMPLATE_URL,
  GET_EVENT_TEMPLATE_URL,
  REGISTER_EVENT_TEMPLATE_URL,
  TOGGLE_EVENT_TEMPLATE_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

/**
 * The layouts an event renders in on a screen. Same five calls the donation
 * `Template` service makes — an event layout is authored and managed the same
 * way, only against the event placeholders.
 */
class EventTemplate {
  static getEventTemplates = async (
    getEventTemplate: GetEventTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EVENT_TEMPLATE_URL, {
      params: getEventTemplate,
    });
    return response;
  };

  static registerEventTemplate = async (
    registerEventTemplate: RegisterEventTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_EVENT_TEMPLATE_URL,
      {
        ...registerEventTemplate,
      }
    );
    return response;
  };

  static editEventTemplate = async (
    editEventTemplate: EditEventTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_EVENT_TEMPLATE_URL,
      {
        ...editEventTemplate,
      }
    );
    return response;
  };

  static toggleEventTemplateIsActive = async (
    editEventTemplate: EditEventTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_EVENT_TEMPLATE_IS_ACTIVE_URL,
      {
        ...editEventTemplate,
      }
    );
    return response;
  };

  static deleteEventTemplate = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_EVENT_TEMPLATE_URL}/${id}`
    );
    return response;
  };
}

export default EventTemplate;
